import Swiper from 'swiper';
import 'swiper/css';

const BREAKPOINT_MD = 768;

function syncCardBodyA11y(card: HTMLElement, expanded: boolean): void {
  const body = card.querySelector<HTMLElement>('.fc-expert-card__body');
  if (!body) return;
  if (window.innerWidth >= BREAKPOINT_MD) {
    body.removeAttribute('aria-hidden');
  } else {
    body.setAttribute('aria-hidden', String(!expanded));
  }
}

function syncAllCardsA11y(): void {
  document.querySelectorAll<HTMLElement>('.fc-expert-card').forEach((card) => {
    const expanded = card.classList.contains('is-expanded');
    syncCardBodyA11y(card, expanded);
  });
}

function toggleCard(card: HTMLElement): void {
  if (window.innerWidth >= BREAKPOINT_MD) return;

  const isExpanded = card.classList.toggle('is-expanded');
  card.setAttribute('aria-expanded', String(isExpanded));
  syncCardBodyA11y(card, isExpanded);
}

function initMobileToggle(): void {
  document.querySelectorAll<HTMLElement>('.fc-expert-card').forEach((card) => {
    card.addEventListener('click', () => toggleCard(card));

    card.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleCard(card);
      }
    });
  });

  syncAllCardsA11y();
  window.addEventListener('resize', () => {
    syncAllCardsA11y();
  });
}

export function initExpertPanels(): void {
  const panels = document.querySelectorAll<HTMLElement>('[data-expert-panel]');

  panels.forEach((el) => {
    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      grabCursor: true,
      slidesOffsetAfter: 0,
      breakpoints: {
        0: {
          enabled: false,
        },
        [BREAKPOINT_MD]: {
          enabled: true,
        },
      },
    });
  });

  initMobileToggle();
}
